import { AGRONOMY_MAX_DURATION_YEARS, API_DATE_FORMAT } from 'appConstants';
import dayjs from 'dayjs';
import type { IValidationField } from 'hooks/useValidations/types';
import { getFixedT } from 'i18next';
import { displayDate } from 'utils';
import * as yup from 'yup';

export default function agreementEndDate({ label = '' }: IValidationField) {
  const t = getFixedT(null, 'CreateAgronomyAgreement', 'CustomerDetails');

  return yup
    .string()
    .label(label)
    .required(t('errors.required'))
    .isValidDate(t('errors.invalidDate', { label }))
    .test('greaterThanStartDate', t('errors.minEndDate'), (value, { parent: { startDate } }) => {
      if (!value || !startDate || !dayjs(startDate).isValid()) {
        return true;
      }

      return dayjs(value).isAfter(dayjs(startDate), 'day');
    })
    .test('maxTwoYearsAfterStartDate', '', (value, { parent: { startDate }, createError }) => {
      if (!value || !startDate || !dayjs(startDate).isValid()) {
        return true;
      }

      const maxDate = dayjs(startDate).add(AGRONOMY_MAX_DURATION_YEARS, 'year');
      if (dayjs(value).isSameOrBefore(maxDate, 'day')) {
        return true;
      }

      return createError({
        message: t('errors.maxEndDate', {
          label,
          maxDate: displayDate(maxDate.format(API_DATE_FORMAT)),
        }),
      });
    });
}
